module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification",
    class: {
      targeted: _vm.item.targeted
    }
  }, [_c('div', {
    staticClass: "notification-heading user-action",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.triggerTarget($event)
      }
    }
  }, [_vm._t("title", [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(_vm._s(_vm.item.title) + " "), (_vm.hasLink) ? _c('a', {
    attrs: {
      "href": _vm.item.link
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-globe"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "flex": "0 1 15%"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash",
    attrs: {
      "title": "Remove Notification"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.triggerDelete($event)
      }
    }
  })])], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa80e64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/behaviors/Standard.vue
// module id = 1088
// module chunks = 0